var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1252 8.35147L8.15372 12.323C7.64354 11.8128 7.32959 11.1143 7.32959 10.3372C7.32959 8.78316 8.5854 7.52734 10.1395 7.52734C10.9165 7.52734 11.6151 7.8413 12.1252 8.35147Z",
    stroke: "#777777",
    strokeWidth: 1.00465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7073 5.44735C13.3338 4.41131 11.764 3.84619 10.1393 3.84619C7.36868 3.84619 4.78641 5.47875 2.98902 8.30433C2.28263 9.41102 2.28263 11.2712 2.98902 12.3779C3.60908 13.3511 4.33118 14.191 5.11606 14.866",
    stroke: "#777777",
    strokeWidth: 1.00465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32959 16.2473C8.22436 16.6241 9.17407 16.8282 10.1395 16.8282C12.9101 16.8282 15.4924 15.1956 17.2898 12.37C17.9962 11.2633 17.9962 9.40316 17.2898 8.29648C17.0308 7.88834 16.7482 7.50375 16.4578 7.1427",
    stroke: "#777777",
    strokeWidth: 1.00465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.894 10.8866C12.69 11.9933 11.7873 12.8959 10.6807 13.1",
    stroke: "#777777",
    strokeWidth: 1.00465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15361 12.3229L2.29053 18.186",
    stroke: "#777777",
    strokeWidth: 1.00465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9883 2.48834L12.1252 8.35142",
    stroke: "#777777",
    strokeWidth: 1.00465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.8143b2a4026b1af04602be67c8023def.svg";
export { ForwardRef as ReactComponent };